import React, {useEffect, useState} from 'react';
// import { URLSearchParams } from 'url';
import {Button, Col, Row} from 'react-bootstrap';
import Select from 'react-select';
import InfiniteScroll from "react-infinite-scroll-component";

import {Fetch} from '../../utils';

const { feline_fetch } = Fetch;

const demo_bk = { 
    color_palettes: [
        { name: 'CP 001', colors: [ '#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523' ] }, 
        { name: 'New palette testing', colors: [ '#ffffff','#f9bd14','#f29b1d','#ef3024'] }, 
    ],
    font_sets: [
        { name: 'Custom font set 1', fonts: [{ name: 'Arial Black', size: 31 }, { name: 'Arial Black', size: 15 }, { name: 'Arial Black', size: 12 }] }, 
        { name: 'Dummy font set 2', fonts: [{ name: 'Times New Roman', size: 33 }, { name: 'Montserrat', size: 18 }, { name: 'Times New Roman', size: 10 }] },
    ]
};

const hardcoded_font_sets = [{"name":"","fonts":[{"name":"Playfair Display","src":"uploads/design_resources/font/PlayfairDisplay-Regular.ttf","size":31},{"name":"Source Sans Pro","src":"uploads/design_resources/font/bf77276d8fb66288edbd259e2fbdbaf5.ttf","size":15},{"name":"Montserrat","src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","size":12}]},{"name":"","fonts":[{"name":"Julius Sans One","src":"uploads/design_resources/font/JuliusSansOne-Regular.ttf","size":31},{"name":"Archivo Narrow","src":"uploads/design_resources/font/fed19b87b64a3930a179ab662845f59d.ttf","size":15},{"name":"Source Sans Pro","src":"uploads/design_resources/font/bf77276d8fb66288edbd259e2fbdbaf5.ttf","size":12}]},{"name":"","fonts":[{"name":"Oswald Semi Bold","src":"uploads/design_resources/font/9dc0acea656335f723c0844c643f9ec5.ttf","size":31},{"name":"EB Garamond","src":"uploads/design_resources/font/a7aad0ccd96691dd706c0320db3e5342.ttf","size":15},{"name":"EB Garamond","src":"uploads/design_resources/font/a7aad0ccd96691dd706c0320db3e5342.ttf","size":12}]},{"name":"","fonts":[{"name":"Cinzel","src":"uploads/design_resources/font/Cinzel-Regular.ttf","size":31},{"name":"Fauna One","src":"uploads/design_resources/font/be8c6b52a05c058bd6734d9d46c2feb3.ttf","size":15},{"name":"Quicksand","src":"uploads/design_resources/font/Quicksand-Regular.ttf","size":12}]},{"name":"","fonts":[{"name":"Bebas Neue","src":"uploads/design_resources/font/ed9eb90dfb4d271e224c9d2726a60ba0.ttf","size":31},{"name":"Montserrat SemiBold","src":"uploads/design_resources/font/1a7e8cab51a3ae7c2f3563765b7c47a4.ttf","size":15},{"name":"Montserrat","src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","size":12}]},{"name":"","fonts":[{"name":"Squada One","src":"uploads/design_resources/font/SquadaOne-Regular.ttf","size":31},{"name":"Caveat","src":"uploads/design_resources/font/869575405bd503eabf2e0de0cc0fac94.ttf","size":15},{"name":"Assistant","src":"uploads/design_resources/font/Assistant-Regular.ttf","size":12}]},{"name":"","fonts":[{"name":"Sacramento","src":"uploads/design_resources/font/934decd37a90a66b70795e8b3c3f7c45.ttf","size":31},{"name":"Alice","src":"uploads/design_resources/font/81975e86e84a0784fa039095baac6330.ttf","size":15},{"name":"EB Garamond","src":"uploads/design_resources/font/a7aad0ccd96691dd706c0320db3e5342.ttf","size":12}]},{"name":"","fonts":[{"name":"Yeseva One","src":"uploads/design_resources/font/964fb8d2dfcae363b33e7e6ba38ec17c.ttf","size":31},{"name":"Josefin Sans Medium","src":"uploads/design_resources/font/1d8f6df455c741b1c3dc9aad17e98477.ttf","size":15},{"name":"Josefin Sans Light","src":"uploads/design_resources/font/b96babd7110c274cc54bcf99a284668e.ttf","size":12}]},{"name":"","fonts":[{"name":"Ubuntu","src":"uploads/design_resources/font/Ubuntu-Regular.ttf","size":31},{"name":"Open Sans","src":"uploads/design_resources/font/0bc6f9b91a8ca74d9f7e56fbc16158bf.ttf","size":15},{"name":"Open Sans Light","src":"uploads/design_resources/font/4030d58e0e29679cdb9f7ec06e66ed1a.ttf","size":12}]},{"name":"","fonts":[{"name":"Abril Fatface","src":"uploads/design_resources/font/ef2b1810d671c12d33e17d553b22da38.ttf","size":31},{"name":"Poppins","src":"uploads/design_resources/font/32a2139e6c134a55f64f0245a17d0b1b.ttf","size":15},{"name":"Poppins Light","src":"uploads/design_resources/font/8e69761388468bdca1363e8b69204b5e.ttf","size":12}]},{"name":"","fonts":[{"name":"Cinzel","src":"uploads/design_resources/font/Cinzel-Regular.ttf","size":31},{"name":"Quattrocento Sans","src":"uploads/design_resources/font/434160ff763d9652a59973e459acd7a0.ttf","size":15},{"name":"Quattrocento Sans","src":"uploads/design_resources/font/434160ff763d9652a59973e459acd7a0.ttf","size":12}]},{"name":"","fonts":[{"name":"Raleway","src":"uploads/design_resources/font/7d8fbb687924c6ea45ed612aafa88e6e.ttf","size":31},{"name":"Roboto Condensed","src":"uploads/design_resources/font/8a0d8832c87d799ec314090acab33c98.ttf","size":15},{"name":"Roboto Condensed","src":"uploads/design_resources/font/8a0d8832c87d799ec314090acab33c98.ttf","size":12}]},{"name":"","fonts":[{"name":"Nixie One","src":"uploads/design_resources/font/5a0996a70f166ca0f8fa5b52e87a8618.ttf","size":31},{"name":"Ledger","src":"uploads/design_resources/font/04a68d0ee6b98cf91d630a386e1800f2.ttf","size":15},{"name":"Ledger","src":"uploads/design_resources/font/04a68d0ee6b98cf91d630a386e1800f2.ttf","size":12}]},{"name":"","fonts":[{"name":"Amatic SC","src":"uploads/design_resources/font/6c34fc586708c2328b2e391fc26cfc6a.ttf","size":31},{"name":"Andika","src":"uploads/design_resources/font/7bf33d4a76b21a541090d13829e85ae4.ttf","size":15},{"name":"Quattrocento Sans","src":"uploads/design_resources/font/434160ff763d9652a59973e459acd7a0.ttf","size":12}]},{"name":"","fonts":[{"name":"Philosopher Bold","src":"uploads/design_resources/font/e00f2607f79ce3b3350b46ba6460c727.ttf","size":31},{"name":"Prompt","src":"uploads/design_resources/font/eab154c46d90bf0d2cf4a29441c3ae03.ttf","size":15},{"name":"Prompt","src":"uploads/design_resources/font/eab154c46d90bf0d2cf4a29441c3ae03.ttf","size":12}]},{"name":"","fonts":[{"name":"Fjalla One","src":"uploads/design_resources/font/FjallaOne-Regular.ttf","size":31},{"name":"Roboto","src":"uploads/design_resources/font/46da41fcef0bb98a32dfe507600d0e49.ttf","size":15},{"name":"Lato","src":"uploads/design_resources/font/d5b7525c42208d0e9fc567d2ef58609c.ttf","size":12}]},{"name":"","fonts":[{"name":"DM Serif Display","src":"uploads/design_resources/font/2454a88e52bdaba275fb03a34daf87b5.ttf","size":31},{"name":"Poppins","src":"uploads/design_resources/font/32a2139e6c134a55f64f0245a17d0b1b.ttf","size":15},{"name":"Roboto","src":"uploads/design_resources/font/46da41fcef0bb98a32dfe507600d0e49.ttf","size":12}]},{"name":"","fonts":[{"name":"Calistoga","src":"uploads/design_resources/font/43062729d51d90b29a627b4c4f4ba117.ttf","size":31},{"name":"Open Sans","src":"uploads/design_resources/font/0bc6f9b91a8ca74d9f7e56fbc16158bf.ttf","size":15},{"name":"Open Sans Condensed Light","src":"uploads/design_resources/font/9592806c5f8b689b04e8abc6e794e5e6.ttf","size":12}]},{"name":"","fonts":[{"name":"Istok Web","src":"uploads/design_resources/font/043b68428bdfb50bcdf1f4e1b3c4567b.ttf","size":31},{"name":"Lora","src":"uploads/design_resources/font/Lora-Regular.ttf","size":15},{"name":"Lora","src":"uploads/design_resources/font/Lora-Regular.ttf","size":12}]},{"name":"","fonts":[{"name":"Merriweather Black","src":"uploads/design_resources/font/5cd603b23f3913d557c5c78ebbbcb0fc.ttf","size":31},{"name":"Merriweather Sans","src":"uploads/design_resources/font/e5a9721591db3d714bc72790b0a81c7d.ttf","size":15},{"name":"Merriweather Sans","src":"uploads/design_resources/font/e5a9721591db3d714bc72790b0a81c7d.ttf","size":12}]},{"name":"","fonts":[{"name":"Montserrat","src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","size":31},{"name":"Raleway","src":"uploads/design_resources/font/7d8fbb687924c6ea45ed612aafa88e6e.ttf","size":15},{"name":"Cardo","src":"uploads/design_resources/font/36021b288bcc19b46b77700e647e8318.ttf","size":12}]}]

// const hardcoded_font_sets = [
//     { name: 'Generic font set 1', fonts: [{ name: 'Comic Sans MS', size: 31 }, { name: 'Impact', size: 15 }, { name: 'Monaco', size: 12 }] },
//     { name: 'Generic font set 2', fonts: [{ name: 'Times New Roman', size: 31 }, { name: 'Verdana', size: 15 }, { name: 'Courier', size: 12 }] },
//     { name: 'Generic font set 3', fonts: [{ name: 'Georgia', size: 31 }, { name: 'Helvetica', size: 15 }, { name: 'Palatino', size: 12 }] },
// ];


const dummy_data = [
    {
        "name": "fonts",
        "data": [
            {
                "_id": "5eba598f6c6cfd18e9c80d5e",
                "name": "Untitled brand fonts",
                "value": {
                    "data": [
                        {
                            "title": "heading",
                            "fontSize": 31.5
                        },
                        {
                            "title": "subheading",
                            "fontSize": 18
                        },
                        {
                            "title": "body",
                            "fontSize": 12
                        }
                    ]
                },
                "created_at": "2020-05-12T08:08:47.578Z",
                "updated_at": "2020-05-12T08:08:47.578Z"
            }
        ]
    }, {
        "name": "colors",
        "data": [
            {
                "_id": "5f37c06d9b873b6444a46864",
                "name": "Untitled palette",
                "value": {
                    "data": [
                        "#ff00e2",
                        "#0061ff",
                        "#ff0083",
                        "#83cc61",
                        "#0072ff",
                        "#00ff05",
                        "#e000ff",
                        "#000aff",
                        "#0053ff",
                        "#d5ff00",
                        "#00ff77",
                        "#d4ff00",
                        "#ff00e2"
                    ],
                    "id": 0,
                    "timestamp": "1597489244",
                    "type": "hex"
                },
                "created_at": "2020-08-15T11:01:01.737Z",
                "updated_at": "2020-08-15T11:01:40.805Z"
            }
        ]
    }
];

const load_font = async ({ name, src, url }) => {
    try {
        if (!url && !src) {
            throw 'no font src provided';
        }
        var file_path = 'url(' + (url ? url : (global.config.server_path + src)) + ')';
        var custom_font = new FontFace(name, file_path);
        var loaded_face = await custom_font.load()
        document.fonts.add(loaded_face);
        document.body.style.fontFamily = '"' + name + '", Arial';
    } catch(err) {
        console.log('error loading font --> ', err);
    }
}

const check_font_load = (font_family) => {
    var font_iterator = document.fonts.entries()
    var entries = font_iterator.next();
    while(entries && entries.value){
        for(var i in entries.value){
            if(entries.value[i].family == font_family){
                return true;
            }
        }
        entries = font_iterator.next();
    }
    return false;
}

const FontBox = ({ font_set }) => {
    try {
        const font_set_onclick = () => {
            
            font_set.fonts.map(o => {
                if(o.file && o.file[0]){
                    o.src = o.file[0];
                }
            })
            window.design_editor.design.fontSwapWithFontTriplets(font_set.fonts.map(o => ({font:o.name,font_src:o.src})));
        }

        return (
            <div style={{ width: "100%", paddingBottom: 6 }} onClick={font_set_onclick}>
                <div style={{ cursor: 'pointer', textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 }}>{font_set.name}</div>
                <div style={{ textAlign: 'left', width: "100%", backgroundColor: 'white', borderRadius: 5, padding: 10 }}>
                    {font_set.fonts.map(font => (
                        <div style={{ cursor: 'pointer',fontFamily: font.name, fontSize: font.fontSize , padding: 2,  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}> {font.name}</div>
                    ))}
                </div>
            </div>
        );
    } catch(err) { 
        console.log('error in font  panel -->', err);
        return 'something went wrong';
    }
}


const FontPanel = ({ font_sets }) => {
    try {
        const [ generic_font_sets, set_generic_font_sets ] = useState([]);

        const fetch_generic_font_sets = () => {
            var all_font_sets = hardcoded_font_sets;
            all_font_sets.map(x => {
                x.fonts.map(y => load_font({ name: y.name, src: y.src }));
            });
            set_generic_font_sets(all_font_sets);
        }

        useEffect(() => {
            fetch_generic_font_sets();
        }, [])

        return (
            <React.Fragment>
                <div style={{padding: 12, width: '100%'}}>
                    <Button className="btn btn-sm btn-block btn-orange" style={{paddingTop: 9, paddingBottom: 9, fontWeight: 500, fontSize: 14}} onClick={() => window.open('https://designs.ai/en/user/brand-kit')}>Add new font set</Button>
                </div>
                <div id="bk_font_box" style={{ padding: 12, paddingTop: 0 }}>
                    {(font_sets && font_sets.length) ? font_sets.map((font_set => (
                        <FontBox font_set={font_set} />
                    ))) : (
                        <div style={{ cursor: 'pointer', textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 }}>You have no font sets</div>
                    )}
                </div>
                <div style={{paddingTop: 12, marginLeft: '-1px', width: 300, backgroundColor: 'white'}} />
                <div style={{ padding: 12, height: 'calc(100vh - 210px - ' + (document.getElementById('bk_font_box') ? document.getElementById('bk_font_box').offsetHeight : 0) + 'px)', overflowY: 'auto', width: '100%' }}>
                    {generic_font_sets && generic_font_sets.length && generic_font_sets.map((font_set => (
                        <FontBox font_set={font_set} />
                    )))}
                </div>
            </React.Fragment>
        );
    } catch(err) {
        console.log('error in font panel -->',err)
        return 'something went wrong';
    }
}


const PaletteBox = ({ palette,last_palette_signature,set_last_palette_signature,last_palette_shuffle_index,set_last_palette_shuffle_index }) => {
    try {
        const apply_palette = () => {
            var current_signature = JSON.stringify(palette.colors);
            var new_shuffle_index, new_colors;
            if(last_palette_signature == current_signature){
                new_shuffle_index = (last_palette_shuffle_index>=palette.colors.length-1)?0:last_palette_shuffle_index+1;
                new_colors = palette.colors.slice(new_shuffle_index,palette.colors.length).concat(palette.colors.slice(0, new_shuffle_index));
            }else{
                new_shuffle_index = 0;
                new_colors = palette.colors.slice(0,palette.colors.length);
            }
            window.design_editor.design.colorSwap(1,new_colors);window.design_editor.addUndoChange();
            set_last_palette_signature(current_signature);
            set_last_palette_shuffle_index(new_shuffle_index);
        }

        return (
            <div style={{ width: "100%" }} onClick={apply_palette}>
                <div style={{ textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 , cursor: 'pointer'}}>{palette.name=='default'?'':palette.name}</div>
                {palette.colors.map(color => (
                    <div style={{ cursor: 'pointer',display: "inline-block", width: Math.floor(100 / palette.colors.length) + "%", backgroundColor: color, height: 30  }}></div>
                ))}
            </div>
        );
    } catch(err) {
        console.log('error in palette', err);
        return 'something went wrong';
    }
}

    
const ColorPanel = ({ color_palettes, color_categories }) => {
    try {
        const [ selected_palette_category, set_selected_palette_category ] = useState(null);
        const [ generic_color_palettes, set_generic_color_palettes ] = useState([]);
        const [ has_more_cp, set_has_more_cp ] = useState(true);
        const [ page, set_page ] = useState(1);
        const [ limit, set_limit ] = useState(60);

        const [last_palette_signature,set_last_palette_signature] = useState("");
        const [last_palette_shuffle_index,set_last_palette_shuffle_index] = useState(0);


        const fetch_color_palettes = async flush => {
            if (!flush) {
                flush = false;
            }
            if (has_more_cp) {
                var data = await feline_fetch({ url: 'design_resource/get_color_palettes', body: { category: selected_palette_category._id, limit, page: flush ? 1 : page } })
                if (data.length) {
                    if (flush) {
                        set_page(1);
                        set_generic_color_palettes([ ...data ]);
                    } else {
                        set_generic_color_palettes([ ...generic_color_palettes, ...data ]);
                    }
                } else {
                    set_has_more_cp(false);
                }
            }
        }

        useEffect(() => {
            if (selected_palette_category && selected_palette_category._id) {
                set_has_more_cp(true);
                set_page(1);
                set_generic_color_palettes([]);
                fetch_color_palettes(true);
            }            
        }, [ selected_palette_category ]);

        useEffect(() => {
            if (color_categories && color_categories.length) {
                set_selected_palette_category(color_categories[0]);
            }
        }, [ color_categories ]); 

        return (
            <div>
                <div style={{padding: 12, width: '100%'}}>
                    <Button className="btn btn-sm btn-block btn-orange" style={{paddingTop: 9, paddingBottom: 9, fontWeight: 500, fontSize: 14}} onClick={() => window.open('https://designs.ai/en/user/brand-kit')}>Add new brand palette</Button>
                </div>
                <div id="palette_box" style={{ padding: 12, paddingTop: 0 }}>
                    {(color_palettes && color_palettes.length) ? color_palettes.map((palette => (
                        <PaletteBox palette={palette} last_palette_signature={last_palette_signature} set_last_palette_signature={set_last_palette_signature} last_palette_shuffle_index={last_palette_shuffle_index} set_last_palette_shuffle_index={set_last_palette_shuffle_index} />
                    ))) : (
                         <div style={{ cursor: 'pointer', textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 }}>You have no color palettes</div>
                    )}
                </div>

                <div style={{paddingTop: 12, marginLeft: '-1px', width: 300, backgroundColor: 'white'}} />
                <div style={{ padding: 12 }}>
                    <Select
                        style={{height: '38px', 'width': '100%'}}
                        styles={{
                            option: (provided, state) => ({
                                ...provided,
                                textAlign: 'left',
                                backgroundColor: state.isSelected ? '#C8CDD4' : (state.isFocused ? '#F1F2F3' : 'white'),
                            })
                        }}
                        value={{
                            label: selected_palette_category ? selected_palette_category.name : null,
                            value: selected_palette_category
                        }}
                        options={color_categories.map(x => ({ value: x, label: x.name }))}
                        onChange={(selection) => {
                            set_selected_palette_category(selection.value)
                        }}
                    />
                </div>
                <div style={{ padding: 12, paddingTop: 0 }}>
                    <InfiniteScroll
                        dataLength={generic_color_palettes ? generic_color_palettes.length : 0}
                        next={fetch_color_palettes}
                        hasMore={has_more_cp}
                        height={'calc(100vh - 210px - ' + (document.getElementById('palette_box') ? document.getElementById('palette_box').offsetHeight : 0) + 'px)'}
                        endMessage={<h4>No more results.</h4>}
                    >
                        {generic_color_palettes && generic_color_palettes.length?(generic_color_palettes.map(palette => (
                            <PaletteBox palette={palette} last_palette_signature={last_palette_signature} set_last_palette_signature={set_last_palette_signature} last_palette_shuffle_index={last_palette_shuffle_index} set_last_palette_shuffle_index={set_last_palette_shuffle_index} />
                        ))):<div></div>}
                    </InfiniteScroll>
                </div>
            </div>
        );
    } catch(err) {
        console.log('error in Color panel -->',err)
        return 'something went wrong';
    }
}


const LogoPanel = () => {
    try {
        return (
            <React.Fragment>
                <div style={{padding: 12, width: '100%'}}>
                    <Button className="btn btn-sm btn-block btn-orange" style={{paddingTop: 9, paddingBottom: 9, fontWeight: 500, fontSize: 14}} onClick={() => window.open('https://designs.ai/en/user/brand-kit')}>Add new logo</Button>
                </div>
            </React.Fragment>
        );
    } catch(err) {
        console.log('error in Logo panel -->',err)
        return 'something went wrong';
    }
}


const TabSwitcher = ({ active_tab, color_categories, font_sets, color_palettes }) => {
    try {
        if (active_tab) {
            switch(active_tab) {
                case 1 : return (
                    <ColorPanel color_categories={color_categories} color_palettes={color_palettes} />
                );
                case 2 : return (
                    <FontPanel font_sets={font_sets} />
                );
                case 3 : return (
                    <LogoPanel />
                );
            };
        } else {
            return '';
        }
    } catch(err) {
        console.log('something went wrong tab switch -->', err);
        return 'something went wrong';
    }
}

const BrandKitPanel = ({ user, color_palettes, font_sets }) => {
    try {
        const [ active_tab, set_active_tab ] = useState(1);
        const [ initialized, set_initialized ] = useState(false);
        const [ color_categories, set_color_categories ] = useState([]);

        const fetch_color_panel_display_categories = async () => {
            try {
                var data = await feline_fetch({ url: 'design_resource/get_display_color_palettes', body: {} })
                set_color_categories(Object.keys(data.category_data).map(x => data.category_data[x]));
            } catch(err) {
                console.log(err);
            }
        }

        useEffect(() => {
            if (!initialized) {
                fetch_color_panel_display_categories();
                set_initialized(true);
            }
        }, []);

        return (
            <React.Fragment>
                <Row>
                    <Col xs={4} style={{padding: 0}}>
                        <Button  className={"btn-lg btn-block btn photo-tab-btn" + (active_tab === 1 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => set_active_tab(1)}>Colors</Button>
                    </Col>
                    <Col xs={4} style={{padding: 0}}>
                        <Button className={"btn-lg btn-block btn photo-tab-btn" + (active_tab === 2 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => set_active_tab(2)}>Fonts</Button>
                    </Col>
                    <Col xs={4} style={{padding: 0}}>
                        <Button className={"btn-lg btn-block btn photo-tab-btn" + (active_tab === 3 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => set_active_tab(3)}>Logos</Button>
                    </Col>
                    
                    
                </Row>
                <TabSwitcher 
                    color_categories={color_categories} 
                    active_tab={active_tab}
                    font_sets={font_sets}
                    color_palettes={color_palettes}
                />
            </React.Fragment>
        );
    } catch(err) {
        console.log('error inb/k panel ---> ', err);
        return 'something went wrong here';
    }
}

export default BrandKitPanel;